export default __webpack_public_path__ + "static/media/icon-ampulheta.4e24bfb2.png";